import { useAppTranslation } from '../i18n/useAppTranslation';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, Typography, Button, Stack } from '@mui/material';
import { Cancel, SportsScore } from '@mui/icons-material';
import { isNativeApp } from '../utils/platform';

const SubscriptionCancel = () => {
  const { tr } = useAppTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isNativeApp()) navigate('/coach/dashboard', { replace: true });
  }, [navigate]);

  if (isNativeApp()) return null;

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)'
    }}>
      <Container maxWidth="xs">
        <Paper elevation={24} sx={{ p: 5, borderRadius: 4, textAlign: 'center' }}>
          <Cancel sx={{ fontSize: 80, color: '#EF4444', mb: 2 }} />
          <SportsScore sx={{ fontSize: 36, color: 'primary.main', mb: 1 }} />
          <Typography variant="h4" fontWeight={900} gutterBottom>
             {tr("Paiement annulé")} </Typography>
          <Typography color="text.secondary" sx={{ mb: 4, lineHeight: 1.7 }}>
             {tr("Tu as annulé le processus de paiement. Ton abonnement n'a pas été activé. Tu peux réessayer à tout moment.")} </Typography>
          <Stack spacing={2}>
            <Button
              variant="contained" size="large" fullWidth
              onClick={() => navigate('/coach/subscription')}
              sx={{ py: 1.8, borderRadius: 3, fontWeight: 800 }}
            >
               {tr("Réessayer le paiement")} </Button>
            <Button
              variant="outlined" size="large" fullWidth
              onClick={() => navigate('/coach/dashboard')}
              sx={{ py: 1.5, borderRadius: 3, fontWeight: 700 }}
            >
               {tr("Retour au dashboard")} </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default SubscriptionCancel;
